module.exports = __webpack_public_path__ + "img/Delete-Icon.57ce9388.svg";